import { HeatsSummaryStatItem } from "./HeatsSummaryStatItem";
import { HeatsSummaryRecipeItem } from "./HeatsSummaryRecipeItem";
import { HeatsSummaryItem as HeatsSummaryItemType } from "src/store/api/generatedApi";

interface HeatsSummaryItemProps {
  item: HeatsSummaryItemType;
}

export const HeatsSummaryItem = ({ item }: HeatsSummaryItemProps) => {
  switch (item.summary_type) {
    case "stat":
      return <HeatsSummaryStatItem item={item} />;
    case "recipe":
      return <HeatsSummaryRecipeItem item={item} />;
    default:
      console.error(
        `Unknown summary type: ${item.summary_type as unknown as string}`
      );
      return null;
  }
};
